import * as React from 'react';

const localCache: Record<string, string> = {};

export default function useResourceLoader(urls: string[], isClientUrl?: boolean) {
    const [isLoaded, setState] = React.useState(false);
    const [response, setResponse] = React.useState<any>({});

    async function load() {
        const caches: Record<string, string> = {};

        for (let i = 0; i < urls.length; i++) {
            const url = urls[i];
            if (localCache[url]) {
                caches[url] = localCache[url];
            } else if (isClientUrl) {
                caches[url] = url;
            } else {
                const response = await fetch(url);
                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);
                caches[url] = blobUrl;
                localCache[url] = blobUrl;
            }
        }

        if (Object.keys(caches).length === urls.length) {
            setResponse(caches);
            setState(true);
        }
    }

    React.useEffect(() => {
        if (!urls?.length) {
            return;
        }
        load();
    }, []);

    return [isLoaded, response];
}
